import React from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    try { localStorage.removeItem("auth"); } catch (err) {}
    if (window.showPreloader) { window.showPreloader(); }
    navigate("/", { replace: true });
  };
  return (
    <nav className="main-header navbar navbar-expand navbar-dark navbar-dark-custom" style={{marginLeft: "0px"}}>
      <div className="container-fluid d-flex align-items-center justify-content-between">
        {/* Left brand */}
        <div className="d-flex align-items-center">
         
          <span className="brand-text ml-2" style={{ fontWeight: 800, fontSize: 18, letterSpacing: 0.6 }}>
            SHIP REPORT PORTAL
          </span>
        </div>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
       

        {/* User Dropdown */}
        <li className="nav-item dropdown">
          <button type="button" className="nav-link btn btn-link d-flex align-items-center" data-toggle="dropdown">
            <img
              src={`${process.env.PUBLIC_URL}/dist/img/manager.png`}
              className="img-circle elevation-2 mr-2"
              alt="Admin Avatar"
              style={{ width: "30px", height: "30px", objectFit: "cover" }}
            />
            <span className="d-none d-md-inline font-weight-bold">Administrator</span>
            <i className="fas fa-caret-down ml-1"></i>
          </button>
          <div className="dropdown-menu dropdown-menu-right shadow-lg">
            <button type="button" className="dropdown-item text-danger" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt mr-2"></i> Logout
            </button>
          </div>
        </li>
        <li className="nav-item">
          <button type="button" className="nav-link btn btn-link" data-widget="fullscreen">
            <i className="fas fa-expand-arrows-alt"></i>
          </button>
        </li>
        </ul>
      </div>
    </nav>
  );
}
